import React, { useEffect, useState } from "react";
import axios from "axios";

export default function HealthCheck() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchStatus = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get("/api/health");
      setStatus(data);
    } catch (err) {
      setStatus({ error: "No se pudo conectar al backend" });
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h2>🔍 Health Check de Servicios</h2>
      <button
        onClick={fetchStatus}
        style={{
          marginBottom: "20px",
          padding: "6px 12px",
          background: "#0275d8",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        🔄 Verificar ahora
      </button>

      {loading ? (
        <p>Cargando...</p>
      ) : status?.error ? (
        <p style={{ color: "red" }}>{status.error}</p>
      ) : (
        <table style={{ borderCollapse: "collapse", width: "100%" }}>
          <thead>
            <tr style={{ background: "#f2f2f2" }}>
              <th style={{ padding: "8px" }}>Servicio</th>
              <th style={{ padding: "8px" }}>Estado</th>
              <th style={{ padding: "8px" }}>Mensaje</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ padding: "8px" }}>AWS</td>
              <td style={{ padding: "8px" }}>
                {status.aws.status === "ok" ? "✅" : "❌"}
              </td>
              <td style={{ padding: "8px" }}>{status.aws.message}</td>
            </tr>
            <tr>
              <td style={{ padding: "8px" }}>OpenAI</td>
              <td style={{ padding: "8px" }}>
                {status.openai.status === "ok" ? "✅" : "❌"}
              </td>
              <td style={{ padding: "8px" }}>{status.openai.message}</td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
}
